const catalogoEstablecimientosRoutes = [
    {
      path: "/establecimientos",
      name: "establecimientos",
      component: () =>
      import(/* webpackChunkName: "establecimientos" */ "../views/EstablecimimientosView.vue"),
    },
  ];
  
export default catalogoEstablecimientosRoutes;